import axios from "axios";
import config from "../../config";
import {
  CompleteTaskParams,
  CompleteTaskResponse,
  TaskInfoParams,
  LongRunningTaskDataModel,
} from "./types";

const apiUrl = config.api;

export const getTaskInfo = async (
  filters: TaskInfoParams,
): Promise<LongRunningTaskDataModel> => {
  const response = await axios.post<LongRunningTaskDataModel>(
    `${apiUrl}/task/new`,
    {
      tableName: filters.tableName,
      statuses: filters.statuses,
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
    },
  );

  return response.data;
};

export const getLongRunningTasks =
  async (): Promise<LongRunningTaskDataModel> => {
    const response = await axios.get<LongRunningTaskDataModel>(
      `${apiUrl}/task/long-running`,
    );

    return Array.isArray(response.data)
      ? { results: response.data }
      : response.data;
  };

export const setTaskAsCompleted = async (
  task: CompleteTaskParams,
): Promise<CompleteTaskResponse> => {
  const response = await axios.post<CompleteTaskResponse>(
    `${apiUrl}/task/set-as-completed`,
    task,
  );

  return response.data;
};

export default getTaskInfo;
